export const funnelReviewsEnhancement = [
	'funnelReviews_review1',
	'funnelReviews_review2',
	'funnelReviews_review3',
];
